// import { selectUser } from '../redux/userReducer';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navbar } from './Navbar';
import { NotificationModal } from './Notifications/detail.component';
import { selectNotificationShow, updateNotificationShow } from '../redux/notificationReducer';

const Layout = ({
  children,
  showNavbar = true,
  navbarCustomSettingComponent,
  layoutClass = 'bg-ato-form-border bg-opacity-10',
  searchBar,
  searchKeyword,
  showNormal = false,
  noArtwork = false,
}) => {

  // const user = useSelector(selectUser);
  const dispatch = useDispatch();

  const notificationShow = useSelector(selectNotificationShow);

  const showNotification = (show) => {
    dispatch(updateNotificationShow(show));
  }

  useEffect(() => {
    const init = async () => {
      const queryOpts = { name: 'clipboard-read', allowWithoutGesture: false };
      const permissionStatus = await navigator.permissions.query(queryOpts);
      // Will be 'granted', 'denied' or 'prompt':
      console.log(permissionStatus.state);
    }
    init();
  }, [])

  return (
    <div className={`w-full min-h-screen ${layoutClass}`}>
      {showNavbar && (
        showNormal ? 
        <div className="px-6 md:px-10 lg:px-12 py-6 md:py-5 lg:py-10">
          <Navbar normalBar={true} disableArtwork={noArtwork}/>
        </div> :
        <div className="px-6 md:px-10 lg:px-12 py-6 md:py-5 lg:py-10">
          <Navbar
            customSettingComponent={navbarCustomSettingComponent}
            searchBar={searchBar}
            searchKeyword={searchKeyword}
            disableArtwork={noArtwork}
          />
        </div>
      )}
      <div className="px-6 md:px-10 lg:px-12 pt-0 md:pt-0 lg:pt-0 ">
        <NotificationModal isModal={notificationShow} setIsModal={showNotification} />
        {children}
      </div>
    </div>
  );
};

export default Layout;
